import { CardContent as MuiCardContent } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

const styles = /* istanbul ignore next */ (theme) => ({
  root: {
    ...theme.typography.body1,
    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
    '& > *': {
      margin: 0,
    },
  },
});

const CardContent = ({ children, ...props }) => (
  <MuiCardContent {...props}>{children}</MuiCardContent>
);

export default withStyles(styles)(CardContent);
